// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"351":"commons","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"351":"475fd942a2ef55b5e5ef","678":"6f8a9848c2bfc0b4b2e5","883":"cd34b2a8d8441634180b"}[chunkId] + ".js";
};